"use client";

import { useEffect, useState } from "react";
import type { BannerContext, PublicBanner } from "@/lib/banners";
import { BannerGrid, inferredPageType } from "./banner-render";

type Props = { position: string; className?: string; context?: BannerContext; wide?: boolean };

/** Reklamlari tarayicidan ister (ayni origin /api/v1). Hata/bos yanitta hicbir sey cizmez. */
export default function BannerSlotClient({ position, className = "", context = {}, wide = false }: Props) {
  const [banners, setBanners] = useState<PublicBanner[]>([]);
  const contextKey = JSON.stringify(context);

  useEffect(() => {
    const controller = new AbortController();
    const params = new URLSearchParams({ position, page_type: inferredPageType(position) });
    for (const [key, value] of Object.entries(JSON.parse(contextKey) as BannerContext)) {
      if (value !== undefined && value !== null && String(value).trim()) params.set(key, String(value));
    }
    fetch(`/api/v1/banners/grid?${params.toString()}`, { signal: controller.signal, credentials: "same-origin" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => { if (Array.isArray(data?.data)) setBanners(data.data as PublicBanner[]); })
      .catch(() => { /* reklam yoksa sayfa etkilenmez */ });
    return () => controller.abort();
  }, [position, contextKey]);

  return <BannerGrid banners={banners} position={position} wide={wide} className={className} />;
}
